import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DatePipe} from "@angular/common";

@Injectable()
export class GradePostTransactionIdService {
    constructor(private http: HttpClient,
                public datePipe: DatePipe) {
    }

    getNewTransactionId(): string {
        const dateTime: string = this.datePipe.transform(new Date(), 'yyyyMMddHHmmssSSSS');

        return (dateTime?.toString() + Math.floor(1 + Math.random() * 9)?.toString())?.trim();
    }
}
